import { render } from "./NotFound.vue?vue&type=template&id=a0b578ce"
const script = {}

import exportComponent from "/home/forge/s.thebuyhive.com/expertsourcing/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__